import { render, staticRenderFns } from "./LastBatteryValue.vue?vue&type=template&id=08919fd2"
import script from "./LastBatteryValue.vue?vue&type=script&lang=js"
export * from "./LastBatteryValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports